// Generated by https?://quicktype.io

import { TenantName } from '@shared/models/tenant-name';
import { TransferBaseModel } from '../transfer-base.model';

export interface TradingAccountRequest {
    currency_lookup?: string;
    leverage_lookup?: string;
    platform_lookup?: string;
    trading_account_type_lookup?: string;
    trading_group?: string;
    account?: string;
}

export interface Request extends TransferBaseModel {
    id?: string;
    staff_linked?: StaffLinked[];
    request?: RequestLookup;
    request_number?: string;
    request_date?: string;
    request_type_lookup?: string;
    request_trading_account?: TradingAccountRequest;
    request_status_lookup?: string;
    request_text?: string;
    request_tenant?: string;
    auto_approve?: boolean;
    actioned_date?: string;
    account?: string;
    trading_account?: string;
    balance?: number;
    currency_lookup?: string;
    account_name?: string;
    tenant?: TenantName;
    crm_sales_team?: string;
}

export interface RequestLookup {
    leverage_lookup?: string;
}

export interface StaffLinked {
    id?: string;
}
